import styled from 'styled-components'

import FONTS from 'constants/fonts'

export const Tags = styled.span`
  font-size: ${FONTS.FONTMEDIUM};
  margin-top: 10px;
  display: block;
`
